import {
  CloudWatchLogsClient,
  PutLogEventsCommand,
  CreateLogStreamCommand,
  DescribeLogStreamsCommand,
} from '@aws-sdk/client-cloudwatch-logs'

const client = new CloudWatchLogsClient({
  region: import.meta.env.VITE_AWS_REGION,
  credentials: {
    accessKeyId: import.meta.env.VITE_AWS_ACCESS_KEY_ID,
    secretAccessKey: import.meta.env.VITE_AWS_SECRET_ACCESS_KEY,
  },
})

async function ensureLogStream(logGroupName: string, logStreamName: string) {
  const describe = new DescribeLogStreamsCommand({
    logGroupName,
    logStreamNamePrefix: logStreamName,
  })
  const result = await client.send(describe)

  const exists = result.logStreams?.some((s) => s.logStreamName === logStreamName)

  if (!exists) {
    const create = new CreateLogStreamCommand({
      logGroupName,
      logStreamName,
    })
    await client.send(create)
  }
}

export const LogMessage = async (logStream: string, message: unknown) => {
  try {
    const logGroupName = import.meta.env.VITE_AWS_LOG_GROUP_NAME
    await ensureLogStream(logGroupName, logStream)

    const params = {
      logGroupName,
      logStreamName: logStream,
      logEvents: [
        {
          message: typeof message === 'string' ? message : JSON.stringify(message),
          timestamp: Date.now(),
        },
      ],
    }

    const command = new PutLogEventsCommand(params)
    return await client.send(command)
  } catch (error) {
    console.error('LogMessage error:', error)
    throw error
  }
}

export const LogErrorMessage = async (logStream: string, message: unknown) => {
  try {
    const logGroupName = import.meta.env.VITE_AWS_ERROR_LOG_GROUP_NAME
    await ensureLogStream(logGroupName, logStream)

    const params = {
      logGroupName,
      logStreamName: logStream,
      logEvents: [
        {
          message: typeof message === 'string' ? message : JSON.stringify(message),
          timestamp: Date.now(),
        },
      ],
    }

    const command = new PutLogEventsCommand(params)
    return await client.send(command)
  } catch (error) {
    console.error('LogErrorMessage error:', error)
    throw error
  }
}
